import {
  BookOpen,
  Building2,
  Calendar,
  Clock3,
  ClipboardCheck,
  ClipboardList,
  CreditCard,
  FileCheck2,
  FileStack,
  FileText,
  FlaskConical,
  Gauge,
  HeartHandshake,
  HeartPulse,
  HelpCircle,
  House,
  Inbox,
  KeyRound,
  Landmark,
  LineChart,
  ListOrdered,
  Lock,
  Settings2,
  MessageCircle,
  MessageSquareWarning,
  MessagesSquare,
  Monitor,
  MonitorSmartphone,
  Package,
  Pill,
  Plug,
  Receipt,
  Rocket,
  Scale,
  ShieldCheck,
  Stethoscope,
  Tags,
  UserPlus,
  Users,
  UsersRound,
  Video,
  Wallet,
  type LucideIcon,
} from 'lucide-react';
import type { PageId } from './pages';

/** Sidebar icons, chosen to match the Admin v2 screenshots as closely as lucide allows. */
export const NAV_ICONS: Record<PageId, LucideIcon> = {
  dashboard: House,
  queue: ListOrdered,
  calendar: Calendar,
  waitingRoom: Monitor,
  registerPatient: UserPlus,
  patients: Users,
  billing: Receipt,
  governmentSchemes: ShieldCheck,
  cashDrawer: Wallet,
  medicalCertificates: FileText,
  complaints: MessageSquareWarning,
  messages: MessageCircle,
  medicals: FileStack,
  inbox: Inbox,
  consentTemplates: FileCheck2,
  doctorsInbox: Inbox,
  myPatients: Stethoscope,
  consultation: Stethoscope,
  referralLetter: FileText,
  mySchedule: Calendar,
  attendance: Clock3,
  myContract: FileCheck2,
  myLocumPay: Wallet,
  myRevenue: LineChart,
  teleconsults: Video,
  videoConsults: Video,
  resultsToReview: FlaskConical,
  chronicCare: HeartPulse,
  mothersChildren: UsersRound,
  safety: ShieldCheck,
  sessions: HeartHandshake,
  compartmentAccess: Lock,
  wellbeingSetup: Settings2,
  labOrders: FlaskConical,
  labResults: Inbox,
  prescriptions: Pill,
  stock: Package,
  medicineLeaflets: FileStack,
  controlledDrugs: ClipboardList,
  panels: FileCheck2,
  panelLimits: Gauge,
  panelUsage: LineChart,
  panelReceivables: Landmark,
  onlinePayments: CreditCard,
  claims: ClipboardList,
  monthlyInvoices: Calendar,
  ageing: LineChart,
  remittances: Landmark,
  knockOff: Scale,
  memberVerification: ShieldCheck,
  books: BookOpen,
  doctorRevenue: LineChart,
  financeLocumPay: Wallet,
  reports: LineChart,
  branches: Building2,
  services: Tags,
  rosters: UsersRound,
  managerSchedules: Calendar,
  managerAttendance: Clock3,
  locums: UserPlus,
  managerLocumPay: Wallet,
  superAdminLocumPay: Wallet,
  discounts: CreditCard,
  auditLog: ClipboardCheck,
  compliance: ShieldCheck,
  dataSecurity: KeyRound,
  approvals: ClipboardCheck,
  staff: Users,
  staffSessions: MonitorSmartphone,
  permissions: KeyRound,
  integrations: Plug,
  groupReports: Gauge,
  goLive: Rocket,
  patientChat: MessageCircle,
  teamMessages: MessagesSquare,
  help: HelpCircle,
};
